import { render, staticRenderFns } from "./CommentOrderModal.vue?vue&type=template&id=7f9e57d2&scoped=true&"
import script from "./CommentOrderModal.vue?vue&type=script&lang=js&"
export * from "./CommentOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9e57d2",
  null
  
)

export default component.exports